import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { onKeyPress } from "../../../utils/forms/utils";

const WorkingHours = ({ field, setValue, setError, handleSubmit, handleCancel }) => {
    const handleChange = (event) => {
        setValue(parseInt(event.target.value, 10));
    };

    const handleError = () => {
        const currentError = field.validation
            .map((check) => check(field.value))
            .find((error) => error);
        if (currentError) {
            setError(currentError);
            return currentError;
        }
        return setError(null);
    };

    const handleBlur = () => {
        handleError();
    };

    return (
        <FormControl error={!!field.error} fullWidth>
            <TextField
                onKeyDown={onKeyPress(() => {
                    if (!handleError()) handleSubmit();
                }, handleCancel)}
                type="number"
                label="Working Hours Per Week"
                value={field.value}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <FormHelperText error>{field.error || " "}</FormHelperText>
        </FormControl>
    );
};

export default WorkingHours;
